import { StoreDataTypeKey, Users } from '@etoh/database/core';
import { hasUserRole, UserRoleApp } from '../../../roles';
import { PageFormComponent } from '../components/layout/page-form/page-form.component';

export type PageFormMode = 'edit' | 'add';

export type EntityWithRoles = { roles?: UserRoleApp[] };

export type PageFormButton = {
  label: string;
  click?: () => void;
  link?: string;
  queryParams?: any;
  visibity?: PageFormMode[];
  isShow?: () => boolean;
  buttons?: PageFormButton[];
  roles?: UserRoleApp[];
} & EntityWithRoles;

export const isShowPageFormButton = (
  button: object & EntityWithRoles,
  user: Users
): boolean => {
  if (!button.roles?.length) {
    return true;
  }

  return button.roles.some((role) => hasUserRole(user, role));
};

export interface PageFormInterface {
  pageForm: PageFormComponent;
  id: number;
  standalone: boolean;
}

export interface PageFormQueryParamsAction {
  type: PageFormMode;
  action: 'archive';
  dataType: StoreDataTypeKey;
  id?: number;
  ids?: number[];
}

export interface PageFormQueryParams {
  model?: any;
  actions?: PageFormQueryParamsAction[];
}

export interface PageFormQueryParamsString {
  model?: string;
  actions?: string;
}
